import React, { useState } from 'react'
import Card from 'antd/es/card/Card'
import { Alert, Button, Form, Input, Modal, Result, message } from 'antd'
import { useRefundOrder } from '../../../requests/order';

import { useParams } from "react-router-dom"
const BkashRefund = () => {

    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState("")

    function moddleToggle(){
        setOpen(!open);
    }

    const param = useParams();
    const { mutate: action, isLoading } = useRefundOrder(); 

    function refund() {

        if(reason ==""){
            message.error('Please enter a reason or return')
            return;
        }
        action({ order_id: param.id, reason }, {
            onSuccess:() => {
                // order data will be updated automatically
                message.success('Refund Success');
                moddleToggle();
            },
            onError: err => {
                message.error(err?.message || 'Something went wrong!');
            }
        });
    }

  return (
    <Card title="Payment Refund">
        <Button onClick={moddleToggle}>Refund Order Payment amount</Button>
        
        <Modal
            title="Confirmation"
            open={open}
            onCancel={moddleToggle}
            okText="Confirm return"
            cancelText="Cancel"
            centered
            footer={[
                <>
                <Button loading={isLoading} onClick={refund} danger key="console">
                    Confirm
                </Button>
                <Button onClick={moddleToggle}  key="cancel">
                    Cancel
                </Button>
                </>
            ]}
            
      >

        <Alert message="Once you refund the payment, it will be returned to the customer's account. Once Success you can't undo it." type="error" />
        <Form layout='vertical'>
            <Form.Item label="Reason">
                <Input.TextArea value={reason} onChange={e => setReason(e?.target?.value)}  /> 
            </Form.Item>
        </Form>

      </Modal>

    </Card>
  )
}

export default BkashRefund